<template>
  <div>
    <b-input-group>
      <b-form-input id="postcode" v-model="postcode" :state="state" autocomplete="postal-code" :disabled="disabled===true" :placeholder="`${$t('Enter Postcode...')}`" />
      <b-input-group-append>
        <b-button size="sm" :disabled="postcode.trim() === ''" @click="onFindAddress">
          {{ $t('Find Address') }}
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <b-modal v-model="showModal" centered>
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t('Please choose your address') }}
        </h5>
        <b-button class="close" @click.stop="close">
          <font-awesome-icon icon="times" />
        </b-button>
      </template>
      <address-select-dropdown v-if="!manualInput" v-model="selectedAddress" :options="allAddresses" />
      <div v-else>
        <validation-observer>
          <validation-provider ref="addressLine1Provider" v-slot="{validated, errors, dirty, valid, invalid}" rules="required">
            <b-form-group :label="$t('Address Line 1')" label-for="addressLine1Input">
              <b-form-input id="addressLine1Input" v-model="addressLine1" :state="(dirty || validated) ? (valid ? null : false) : null" />
              <b-form-invalid-feedback :state="invalid" :force-show="invalid">
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <b-form-group :label="$t('Address Line 2')" label-for="addressLine2Input">
            <b-form-input id="addressLine2Input" v-model="addressLine2" />
          </b-form-group>
          <b-form-group :label="$t('Town/City')" label-for="townInput">
            <validation-provider ref="addressTownProvider" v-slot="{validated, errors, dirty, valid, invalid}" rules="required">
              <b-form-input id="townInput" v-model="addressTown" :state="(dirty || validated) ? (valid ? null : false) : null" />
              <b-form-invalid-feedback :state="invalid" :force-show="invalid">
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </b-form-group>
          <b-form-group :label="$t('County')" label-for="countyInput">
            <b-form-input id="countyInput" v-model="addressCounty" />
          </b-form-group>
          <b-form-group :label="$t('Postcode')" label-for="postcodeInput">
            <validation-provider ref="postcodeProvider" v-slot="{validated, errors, dirty, valid, invalid}" rules="required">
              <b-form-input id="postcodeInput" v-model="postcode" :state="(dirty || validated) ? (valid ? null : false) : null" />
              <b-form-invalid-feedback :state="invalid" :force-show="invalid">
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </div>

      <template v-slot:modal-footer>
        <div v-if="!manualInput" class="w-100 text-center">
          <b-button variant="outline-secondary" size="sm" @click="onShowManualInput">
            {{ $t('My address is not listed') }}
          </b-button>
        </div>
        <div v-else>
          <b-button variant="primary" size="sm" @click.prevent="onSaveManualAddress">
            Save
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {ValidationProvider, ValidationObserver} from 'vee-validate';
import AddressSelectDropdown from "@/components/control/AddressSelectDropdown";

export default {
  name: "AddressFinder",
  components: {ValidationProvider, ValidationObserver, AddressSelectDropdown},
  props:['state', 'showAddressInput', 'country', 'disabled'],
  data() {
    return {
      postcode: '',
      allAddresses: [],
      showModal: false,
      selectedAddress: null,
      manualInput: false,
      addressLine1: '',
      addressLine2: '',
      addressTown: '',
      addressCounty: '',
    }
  },
  methods: {
    onFindAddress() {
      this.$api.address.listByPostcode(this.postcode, this.country).then((result) => {
        this.allAddresses = result.data.data;
        this.showModal = true;
        this.manualInput = false;
      });
    },
    onShowManualInput() {
      if (this.showAddressInput === true) {
        this.manualInput = true;
      } else {
        this.showModal = false;
      }
    },
    onSaveManualAddress() {
      const requiredFields = ['postcode', 'addressLine1', 'addressTown'];

      let isFormValid = true;
      for (const field of requiredFields) {
        if (this.$refs[`${field}Provider`]) {
          this.$refs[`${field}Provider`].validate().then((result) => this.$refs[`${field}Provider`].applyResult(result));
        }
        if (this[field] === '') {
          isFormValid = false;
        }
      }

      if (isFormValid) {
        this.$emit('addressSelected', {
          line1: this.addressLine1,
          line2: this.addressLine2,
          town: this.addressTown,
          postcode: this.postcode,
          county: this.addressCounty,
        });
        this.showModal = false;
      }
    }
  },
  watch: {
    selectedAddress() {
      if (this.selectedAddress !== null) {
        this.$api.address.findById(this.selectedAddress).then((result) => {
          const address = result.data.data;
          this.showModal = false;
          this.$emit('addressSelected', {
            line1: address.line1,
            line2: address.line2,
            town: address.post_town,
            postcode: address.postcode,
            county: address.county,
          });
        });
      }
    },
    showModal() {
      this.selectedAddress = null;
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .modal-content {
    overflow: unset;
  }
}
</style>
